import { Source } from '../../../types/custom-worksheet-v2';
import Atosa from '../../../assets/atosa.png';
import RelativeTimestamp from '../../../components/RelativeTimestamp';
import { BadgeV3, ButtonV2, Modal, TooltipV2 } from '@cimplico/components';
import { CheckCircleIcon, ExclamationCircleIcon } from '@heroicons/react/20/solid';
import { useState } from 'react';

type SchemaSourcesProps = {
    sources: Source[];
};
function SchemaSources({ sources }: SchemaSourcesProps): JSX.Element {
    // We don't want to show cimplico as a badge
    const externalSources = sources.filter((s) => s.provider !== 'cimplico');

    if (sources.length === 0) {
        return <></>;
    }
    return (
        <ul className="space-y-4">
            {externalSources.map((es) => {
                return <SchemaSource key={es.resource} source={es} />;
            })}
        </ul>
    );
}

type SchemaSourceProps = {
    source: Source;
};
function SchemaSource({ source }: SchemaSourceProps): JSX.Element {
    const isSuccess = source.syncResult.outcome === 'success';

    return (
        <li className="border rounded-md px-4 py-1 flex items-center gap-4 flex-wrap">
            {/* Logo */}
            <div className="border p-1 rounded-md w-fit">
                <img src={Atosa} className="h-6 w-6" />
            </div>
            <p className="text-gray-800 font-medium flex-1">Atosa</p>
            <p className="text-sm text-gray-600 flex items-center">
                Last sync: <RelativeTimestamp date={source.lastSynced} className="ml-1" />
            </p>

            <TooltipV2 disabled={isSuccess} message={source.syncResult.outcome === 'error' ? (source.syncResult.reason as string) : ''}>
                <BadgeV3
                    color={isSuccess ? 'green' : 'red'}
                    label={isSuccess ? 'Connected' : 'Sync Error'}
                    leftIcon={isSuccess ? <CheckCircleIcon /> : <ExclamationCircleIcon />}
                />
            </TooltipV2>
        </li>
    );
}

export default SchemaSources;
